<template>   
  <div  ref="container" style="width:100%;display:flex;flex:1 1 auto;flex-direction:column">    
    <template v-if="loadingData">      
      <v-progress-circular :width="15" :size="350" :value="loadingValue" color="primary"  style="align-self:center;margin-bottom:auto;margin-top:auto">
        <span class="headline">{{$t('Pilot.Graphics.LoadingData')}}</span>
      </v-progress-circular>                
    </template>
    <template v-else-if="datas.length > 0">  
      <v-toolbar height="40"  ref="toolbar" class="pt-2 elevation-0" style="z-index:10">      
        <v-menu offset-y>
            <v-btn small slot="activator" color="primary" dark :title="$t('Pilot.Graphics.ZoomBehaviourTooltip')">{{tryTranslate(zoomVariable)}}<v-icon right dark>mdi-magnify-plus</v-icon></v-btn>
            <v-list>
              <v-list-tile v-for="zoom in ['ZoomXAxis','ZoomYAxis','Both']" :key="zoom" 
                          @click="$store.myActions.UI_SET_GRA_ZOOM({uiid,zoom})">
                      <v-list-tile-title>{{ tryTranslate(zoom) }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
        </v-menu>  
        <v-menu offset-y>
            <v-btn small slot="activator" color="primary" dark :title="$t('Pilot.Graphics.PointSizeTooltip')">{{pointSize}}{{voronoiLabel}}<v-icon right dark>mdi-chart-bubble</v-icon></v-btn>
            <v-list>
              <v-list-tile v-show="canUseVoronoi">
                <v-switch class="sm-switch" :checked="useVoronoi" @change="$store.myActions.UI_TOGGLE_GRA_VORONOI(uiid)" :label="$t('Pilot.Graphics.VoronoiCellRender')" />
              </v-list-tile>
              <v-list-tile v-for="size in [1,2,3,4,5]" :key="size" 
                          @click="$store.myActions.UI_SET_GRA_POINT_SIZE({uiid,size})">
                      <v-list-tile-title>{{ size }}</v-list-tile-title>
              </v-list-tile>            
            </v-list>
        </v-menu>             
        <v-menu offset-y max-height="97%">
            <v-btn small icon slot="activator" color="primary" dark :title="$t('Pilot.Graphics.XAxisVariableTooltip')"><v-icon small >mdi-axis-y-arrow</v-icon></v-btn>            
            <v-list>
              <v-list-tile v-for="(plotVariable,idx) in abscisseList" :key="`abs_${plotVariable.variable}_${idx}`" 
                          @click="$store.myActions.UI_SET_GRA_ABSCISSE({uiid,abscisse:plotVariable.variable})">
                      <v-list-tile-title>                                           
                        <v-icon v-text="graphUiState.variableX == plotVariable.variable?'mdi-radiobox-marked':'mdi-radiobox-blank'" />  
                        {{ tryTranslate(plotVariable.name) }}
                      </v-list-tile-title>
              </v-list-tile>
            </v-list>
        </v-menu> 
        <v-menu offset-y max-height="97%" >
            <v-btn small icon slot="activator" color="primary" dark :title="$t('Pilot.Graphics.YAxisVariableTooltip')"><v-icon small >mdi-axis-z-arrow</v-icon></v-btn>
            <v-list>
              <v-list-tile v-for="(plotVariable,idx) in plotVariables" :key="`ord_${plotVariable.variable}_${idx}`" 
                          @click="$store.myActions.UI_SET_GRA_ORDONNEE({uiid,ordonnee:plotVariable.variable})">
                      <v-list-tile-title>                        
                        <v-icon v-text="graphUiState.variableY == plotVariable.variable?'mdi-radiobox-marked':'mdi-radiobox-blank'" />  
                        {{ tryTranslate(plotVariable.name) }}
                      </v-list-tile-title>
              </v-list-tile>
            </v-list>
        </v-menu>   
        <v-menu offset-y max-height="97%" >
            <v-btn small icon slot="activator" color="primary" dark :title="$t('Pilot.Graphics.ColorAxisVariableTooltip')"><v-icon small>mdi-palette</v-icon></v-btn>
            <v-list>
              <v-list-tile v-for="(plotVariable,idx) in colorList" :key="`col_${plotVariable.variable}_${idx}`" 
                          @click="$store.myActions.UI_SET_GRA_COLOR({uiid,color:plotVariable.variable})">
                      <v-list-tile-title>                        
                        <v-icon v-text="graphUiState.variableColor == plotVariable.variable?'mdi-radiobox-marked':'mdi-radiobox-blank'" />  
                        {{ tryTranslate(plotVariable.name) }}
                      </v-list-tile-title>
              </v-list-tile>
            </v-list>
        </v-menu>  
        <v-menu offset-y>
            <v-btn small icon slot="activator" color="primary" dark :title="$t('Pilot.Graphics.LastDataModeTooltip')"><v-icon small >mdi-av-timer</v-icon></v-btn>
            <v-list>
              <v-list-tile v-for="dataLimitMode in $options.dataLimitModes" :key="dataLimitMode"   :class="{'selected': dataLimitMode == dataLimit }"
                          @click="$store.myActions.UI_SET_GRA_DATA({uiid,name:'dataLimit',value:dataLimitMode})">
                      <v-list-tile-title>{{ $t(`Pilot.Graphics.LimitData${dataLimitMode}`) }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
        </v-menu>                           
        <div class="d-flex flex-grow-1 align-self-start" style="position:relative;">               
          <div class="pa-1 hoverdata" v-if="hoverData">
            {{$t('Pilot.Graphics.Cycle')}} : {{hoverData.yosCycle}} <br/>
            {{tryTranslate(abscissePlotvariable.name)}} : {{this.hoverAbscisseFormatedValue}} <br/>
            {{tryTranslate(ordonneePlotvariable.name)}} : <template v-if="ordonneePlotvariable.variables"><span class="commasep" v-for="(variable,index) in ordonneePlotvariable.variables" :key="`ord2_${variable}_${index}`">{{tryTranslate(ordonneePlotvariable.infosVariables[index])}} {{hoverData[variable]}} <span v-show="ordonneePlotvariable.unit">{{ordonneePlotvariable.unit}}</span></span></template>
                                                          <template v-else>{{hoverData[ordonneeVariable]}} <span v-show="ordonneePlotvariable.unit">{{ordonneePlotvariable.unit}}</span></template>
            <br/>
            <span v-show="colorVariable != 'None'">{{tryTranslate(colorPlotvariable.name)}} : {{hoverData[colorVariable]}} <span v-show="colorPlotvariable.unit">{{colorPlotvariable.unit}}</span></span>
          </div>   
          <v-spacer />
          <v-btn v-if="!simuGraph" class="flex-grow-0" small  icon @click.stop.prevent="showNew = true;newConfig=''" :title="$t('Pilot.Graphics.SaveConfigTooltip')"  ><v-icon >mdi-content-save-cog</v-icon></v-btn>                     
          <v-menu class="flex-grow-0" v-if="!simuGraph && availableGraphicsConfigs.length > 0" offset-y max-height="97%">
              <v-btn small icon slot="activator" :title="$t('Pilot.Graphics.LoadConfigTooltip')"><v-icon>mdi-cog-counterclockwise</v-icon></v-btn>
              <v-list dense>
                  <v-list-tile v-for="(graphConfig,idx) in availableGraphicsConfigs" :key="idx" 
                            @click="applyGraphState(graphConfig)">
                    <v-list-tile-title>{{ graphConfig.name }}</v-list-tile-title>              
                    <v-list-tile-action><v-spacer/><v-btn small icon @click.stop="deleteConfig(graphConfig)"><v-icon small>mdi-delete</v-icon></v-btn></v-list-tile-action>
                </v-list-tile>
              </v-list>
          </v-menu>            
          <v-btn class="flex-grow-0" small icon @click.stop.prevent="$store.myActions.UI_SHOW_CHART_CONFIG_DIALOG(uiid)" :title="$t('Pilot.Graphics.ConfigAxisTooltip')"  ><v-icon >mdi-cog</v-icon></v-btn>  
          <v-btn class="flex-grow-0" small icon @click.stop.prevent="refresh" :title="$t('Pilot.Graphics.ResetGraphTooltip')" ><v-icon >mdi-refresh</v-icon></v-btn>  
        </div>        
      </v-toolbar> 
      <v-flex>        
        <mission-scatter-plot-web-gl  ref="scatter"   
              :sciGraph="sciGraph"      
              :simuGraph="simuGraph"      
              :pointSize="pointSize" 
              :abscisseVariable="abscisseVariable"
              :ordonneeVariable="ordonneeVariable"
              :colorVariable="colorVariable"
              :uiid="uiid"                                    
              :marginWidth="15"                 
              :offsetLegendX="10"
              :offsetLegendY="5"  
              :colorGradientWidth="10"            
              :offsetLegendColor="5"      
              :xTicks="8"               
              :redraw="componentRefresh"   
              :useVoronoi="useVoronoi"    
              :colorMin="colorMin"          
              :colorMid="colorMid"
              :colorMax="colorMax"
              :custDomainX="custDomainX"
              :custDomainY="custDomainY"
              :custDomainColor="custDomainColor"
              :dataLimit="dataLimit"
              :autoScaleX="autoScaleX"
              :autoScaleY="autoScaleY"
              :mission="mission"
              :tabState="tabState"
              />  <!---->    

      </v-flex>
    </template>
    <template v-else>
      <span class="display-2" style="margin:auto">{{$t('Pilot.Graphics.NoDataAvailable')}}</span>
    </template>
     <v-dialog v-model="showNew"  max-width="800">
      <v-card  > 
        <v-card-title>{{$t('Pilot.Graphics.SaveConfigTooltip')}}</v-card-title>          
        <v-card-text >
          <v-text-field :label="$t('Pilot.Graphics.ConfigName')" v-model="newConfig"></v-text-field>
        </v-card-text>
        <v-card-actions>          
          <v-spacer />
          <v-btn @click="showNew = false">{{$t('Admin.Cancel')}}<v-icon right>mdi-cancel</v-icon></v-btn>
          <v-btn @click="addCurrentChartConfig()">{{$t('Admin.Save')}}<v-icon right>mdi-content-save</v-icon></v-btn>
        </v-card-actions>        
      </v-card>
    </v-dialog> 
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'    
  import * as d3 from 'd3'    
  import MissionScatterPlotWebGl from '@/components/charts/MissionScatterPlotWebGl.vue'
  import MissionScatterPlot from '@/components/charts/MissionScatterPlot.vue'
  import {buildMissionUIStateId} from '@/models/ui/MissionUiState'
  import { dataLimitMode } from '@/models/ui/GraphUiState'
  import { DataPoolEnseigneKeys, buildDataEnseigneKey } from '@/enum/DataPool'
  import {GraphConfig} from '@/models/datapool/GraphConfig'
  import { AloDataPoolItem } from '@/models/alo/AloDataPoolItem'
  import { cloneDeep, trim } from 'lodash'
  import deepEqual from 'deep-equal'
  import { AloMission } from '@/models/alo/AloMission'
import { buildCoverageIterationMissionUiStateId } from '@/models/ui/CoverageIterationMissionUiState'
import { buildCoverageIterationUiStateId } from '@/models/ui/CoverageIterationUiState'

  
  export default {
   components:{MissionScatterPlotWebGl,MissionScatterPlot},
   name: "MissionDetailGraphics",     
   props:  {
      isleft:Boolean,
      uiid:{
          type: String,
          required: true
      },
      sciGraph:{
        type:Boolean,
        required: true
      },
      simuGraph:{
        type:Boolean,
        required: false
      },
      mission:{
        type:AloMission,
        required:true
      },
      tabState:{
        required:true
      }
   }, 
   data(){
     return {
        interval: {},
        loadingValue: 0,
        newConfig:'',
        showNew:false
      }
   },
   mounted() {     
     if(this.loadingData){
      this.interval = setInterval(() => {
        this.loadingValue = (this.loadingValue + 10) % 110        
      }, 1000)
     }
   },  
   created() {
      this.$store.myActions.UI_ENSURE_GRA_STATE({uiid:this.uiid,config:{
          variableX:this.sciGraph?"NAV_DEPTH":this.simuGraph?"datSimu":"datNav",
          variableY:this.sciGraph?"NAV_DEPTH":this.simuGraph?"duration":"roll"
      }})
      if(this.mission.misId != null) {                  
        if(this.sciGraph) this.$store.myActions.MISSION_ENSURE_DATA_SCIENCE(this.mission.misId)
        else if(!this.simuGraph) this.$store.myActions.MISSION_ENSURE_DATA_NAVIGATION(this.mission.misId)
      }
      this.$store.myActions.DATAPOOL_ENSURE({fullKey:this.datapool_graphics_key})
      this.$options.dataLimitModes = [dataLimitMode.LAST_12H,dataLimitMode.LAST_24H,dataLimitMode.ALL]
   },
   computed: {
       ...mapGetters([                     
         'uistatebyuiid',         
      ]),  
      datapool_graphics_key(){
        return buildDataEnseigneKey(this.$store.myGetters.userProfile.ensId,DataPoolEnseigneKeys.graphics)
      },
      graphicsConfigs() {
        return GraphConfig.createGraphConfigs(this.$store.myGetters.dataPoolItemsValueByKey(this.datapool_graphics_key))
      },
      availableGraphicsConfigs(){
        return this.graphicsConfigs.filter(c => c.sciGraph == this.sciGraph && this.abscisseList.some(a => a.variable == c.config.variableX) && this.plotVariables.some(a => a.variable == c.config.variableY) && (c.config.variableColor == "None" || this.plotVariables.some(a => a.variable == c.config.variableColor)))
      },
      currentLang(){
        return this.$i18n.locale
      },      
      datas() {
        return this.sciGraph?this.mission.dataScience:this.simuGraph?this.mission.dataSimulation:this.mission.dataNavigation //.filter(data => data.yosCycle>=this.currentRangeCycle[0] && data.yosCycle<=this.currentRangeCycle[1])
      },   
      loadingData(){
        return this.sciGraph?!this.mission._dataScienceLoaded:this.simuGraph?false:!this.mission._dataNavigationLoaded //.filter(data => data.yosCycle>=this.currentRangeCycle[0] && data.yosCycle<=this.currentRangeCycle[1])
      },
      canUseVoronoi(){
        return false // this.colorVariable != 'None' && this.abscisseVariable == this.mission.xSciScatterVariable && this.ordonneeVariable == this.mission.ySciScatterVariable
      },              
      voronoiLabel() {       
       return this.useVoronoi && this.canUseVoronoi?` - ${this.$t('Pilot.Graphics.VoronoiCellRender')}`:""
      },
      plotVariables(){
        return this.sciGraph?this.mission.sciPlotVariables:this.simuGraph?this.mission.simuPlotVariables:this.mission.navPlotVariables
      },
      abscisseList() {        
        return this.plotVariables.filter(v => !v.variables)
      },
      colorList(){
        return [{variable:'None',name:'None'},...(this.abscisseList)]
      },      
      graphUiState() {          
        //retourne un GraphUiState        
        return this.uistatebyuiid(this.uiid)
      },   
      missionUiid(){        
        return this.mission.covId?buildCoverageIterationMissionUiStateId(buildCoverageIterationUiStateId(this.mission.covId,this.graphUiState.typeUiid),`GLIDER${this.mission.misIdx+1}`) :buildMissionUIStateId(this.mission.misId,this.graphUiState.typeUiid)        
      },
      missionState(){
        return this.mission.covId?this.$store.myGetters.coverageIterationMissionUiStateByUiid(this.missionUiid):this.uistatebyuiid(this.missionUiid)
      },
      componentRefresh() {               
        return this.graphUiState && this.graphUiState.refresh
      },
      pointSize(){
        return this.graphUiState.pointSize
      },      
      colorMin(){
        return this.graphUiState.colorMin
      },      
      colorMid(){
        return this.graphUiState.colorMid
      },      
      colorMax(){
        return this.graphUiState.colorMax
      },      
      custDomainX(){
        return this.graphUiState.custDomainX
      },
      custDomainY(){
        return this.graphUiState.custDomainY
      },
      custDomainColor(){
        return this.graphUiState.custDomainColor
      },
      dataLimit(){
        return this.graphUiState.dataLimit
      },
      useVoronoi(){
        return this.graphUiState.useVoronoi
      },
      hoverData() {                
        return this.sciGraph?this.missionState.sciHoverData:this.simuGraph?this.missionState.simuHoverData:this.missionState.navHoverData
      },
      hoverAbscisseFormatedValue() {
        if(this.hoverData == null) return ''
        return this.abscissePlotvariable.typeData == "date"?
                      `${this.$options.filters.formatDate(this.hoverData[this.abscisseVariable],"DD/MM/YYYY HH:mm:ss")}Z`
                    : `${this.hoverData[this.abscisseVariable]}${this.abscissePlotvariable.unit?this.abscissePlotvariable.unit:''}`
      },      
      abscissePlotvariable(){
        return this.plotVariables.find(v => v.variable == this.abscisseVariable)
      },
      abscisseVariable(){
        return this.graphUiState?.variableX
      },
      ordonneePlotvariable(){
        return this.plotVariables.find(v => v.variable == this.ordonneeVariable)
      },
      ordonneeVariable(){
        return this.graphUiState?.variableY 
      },   
      zoomVariable(){
        return this.graphUiState?.zoom
      },
      colorPlotvariable(){
        return this.colorList.find(v => v.variable == this.colorVariable)
      },
      colorVariable(){
        return this.graphUiState?.variableColor 
      },
      autoScaleX(){
        return this.graphUiState?.autoScaleX
      },
      autoScaleY(){
        return this.graphUiState?.autoScaleY
      },  
      configChartList(){
        return []
      } 
    },  
    watch : {
      uiid(newValue) {        
        this.$store.myActions.UI_ENSURE_GRA_STATE({uiid:newValue,config:{
         variableX:this.sciGraph?"NAV_DEPTH":this.simuGraph?"datSimu":"datNav",
         variableY:this.sciGraph?"NAV_DEPTH":this.simuGraph?"duration":"roll"
        }})
      },
      mission(newValue) {
        if(newValue.misId != null) {   
          if(this.mission.covId) {            
            if(this.sciGraph) this.$store.myActions.COVERAGEITERATION_ENSURE_DATA_SCIENCE(newValue.covId,`GLIDER${this.mission.misIdx+1}`)
            //else if(!this.simuGraph) this.$store.myActions.COVERAGEITERATION_ENSURE_DATA_NAVIGATION(newValue.covId,`GLIDER${this.mission.misIdx+1}`)
          }
          else if(this.mission.isVirtual){
            if(this.sciGraph) this.$store.myActions.MISSIONVIRTUAL_ENSURE_DATA_SCIENCE(newValue.misId)
            //else if(!this.simuGraph) this.$store.myActions.MISSIONVIRTUAL_ENSURE_DATA_NAVIGATION(newValue.misId)    
          }
          else
          {
            if(this.sciGraph) this.$store.myActions.MISSION_ENSURE_DATA_SCIENCE(newValue.misId)
            else if(!this.simuGraph) this.$store.myActions.MISSION_ENSURE_DATA_NAVIGATION(newValue.misId)          
          }           
        }
      },
      loadingData(newValue) {
        if(!newValue) {
          clearInterval(this.interval)
        }
      }, 
      abscisseVariable(newValue)  {
        this.updateGraphName()
      },
      ordonneeVariable(newValue)  {
        this.updateGraphName()
      },
      colorVariable(newValue)  {
        this.updateGraphName(false)
      },
    },
    beforeDestroy () {
      clearInterval(this.interval)
    },
    methods: {    
      updateGraphName(refresh = true) {
        if(this.graphUiState){
          const isDate = this.abscisseVariable == "PLD_REALTIMECLOCK" || this.abscisseVariable == "datNav" || this.abscisseVariable == "datSimu"
          const isDepth = this.ordonneeVariable == "NAV_DEPTH"
          const hasColor = this.colorVariable != "None"
          const isSimple = (this.abscisseVariable == "datNav" || this.abscisseVariable == "datSimu" )  && this.colorVariable == "None"        
          const title = trim(isSimple?this.ordonneePlotvariable.name:`${!isDate?`${isDepth && this.colorVariable == "None"?'Profile ':''}${this.tryTranslate(this.abscisseVariable)}`:''} ${isDepth?'':this.tryTranslate(this.ordonneeVariable)} ${hasColor?`${isDate?'Color ':''}${this.tryTranslate(this.colorVariable)}`:''}`)
          //console.log(title)
          const uiidParts = this.uiid.split('-')          
          if(uiidParts.length == 2) {
            //Test si on est dans le cas d'une simulation de fin de mission ou dans une simulation            
            //this.$store.myActions.MISSION_RENAME_DETAIL({cmp:uiidParts[0],id:Number.parseInt(uiidParts[1]),isleft:this.isleft,label:title})
            //this.$store.myActions.UI_RENAME_DETAIL({cmp:uiidParts[0],id:Number.parseInt(uiidParts[1]),isleft:this.isleft,label:title})                        
            const tabsUI = this.isleft ? this.tabState.tabsleft : this.tabState.tabsright
            const newIdx = tabsUI.tabs.findIndex(it => it.cmp == uiidParts[0] && it.id == Number.parseInt(uiidParts[1]))
            if (newIdx > -1) {              
              tabsUI.tabs[newIdx].label = title
            }
          }
          if(refresh) this.$nextTick(() => this.refresh())
        }
      },
      tryTranslate(key) {        
        const transKey = `Pilot.Graphics.${key}`
        const trad = this.$t(transKey)
        return transKey == trad?key:trad
      },
      refresh() {                          
          this.$refs.scatter.refresh()
      },
      addCurrentChartConfig(){
        this.saveChartConfig([...this.graphicsConfigs,new GraphConfig({name:this.newConfig.length > 0?this.newConfig:`${this.graphUiState.variableX} - ${this.graphUiState.variableY}`,sciGraph:this.sciGraph,config:this.graphUiState})])
      },
      saveChartConfig(configs) {        
        this.saving = true
        this.showNew = false
        this.$store.myActions.DATAPOOL_UPDATE_REQUEST(
            new AloDataPoolItem({
            dtaValue:JSON.stringify(configs),
            dtaKey:this.datapool_graphics_key
          })).finally(()=>{
            this.newConfig = ""
            this.saving = false
          })
      },
      applyGraphState(graphConfig){        
        const config = cloneDeep(graphConfig.config)
        this.$store.myActions.UI_SET_GRA_STATE({uiid:this.uiid,config}).then(()=> {
          const uiidParts = this.uiid.split('-')
          if(uiidParts.length == 2) this.$store.myActions.MISSION_RENAME_DETAIL({cmp:uiidParts[0],id:Number.parseInt(uiidParts[1]),isleft:this.isleft,label:graphConfig.name})
          this.refresh()
        })
      },
      deleteConfig(graphConfig) {
        this.$confirm(this.$t('Admin.DeleteDialogMessage').toString()).then((answer) => {
          if (answer) {
            const newConfig = [...this.graphicsConfigs]
            const idx = newConfig.findIndex(i => deepEqual(i,graphConfig))
            if(idx > -1) {
              newConfig.splice(idx,1)
              this.saveChartConfig(newConfig)
            }
          } 
        })            
      }
    }      
  }
</script>
<style>
.commasep + .commasep:before{
  content: ", ";
}
</style>
<style scope>
.hoverdata{
  border:1px solid #aaa;    
  font-size:11px;
  line-height:12px;  
  background-color:#ffffffdc;
  border-radius:5px;
  position: absolute;  
  z-index:10;
  width: auto;
}

.selected{
  background-color: var(--secondary-color);
  color:white;
}

</style>